module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-900italic.ebf6d16.woff2";